import DeleteActivityLogsButton from "@app/components/history/web/DeleteActivityLogsButton.vue"
import WorkspaceActivityLogs from "@app/components/history/web/WorkspaceActivityLogs.vue"

export const ActivityLogsComponent = WorkspaceActivityLogs
export const ActivityLogsHeaderItem = DeleteActivityLogsButton
